<template>
  <el-dialog
    :visible.sync="visible"
    title=""
    width="874px"
    custom-class="pay-dialog"
    :before-close="handleWxPayClose"
    :close-on-click-modal="false"
  >
    <div class="p-main cf ac">
      <div class="rf ac p-header">
        <img src="@/assets/img/pay/wechat-pay.png" alt="" />
        微信扫一扫付款
      </div>
      <div class="p-price">¥{{ orderInfo.money }}</div>
      <vue-qr
        backgroundColor="#fff"
        :text="payUrl"
        :margin="0"
        :size="170"
      ></vue-qr>
      <div class="rf ac p-scan">
        <img src="@/assets/img/pay/wechat-scan.png" alt="" />
        <p>打开微信<br />扫一扫付款</p>
      </div>
    </div>
    <!--  :logoSrc="" -->
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr/src/packages/vue-qr.vue'

export default {
  name: '',
  components: {
    VueQr
  },
  props: ['visible', 'payUrl', 'orderInfo'],
  data () {
    return {
      checkFunc: null
    }
  },
  created () {},
  watch: {
    async visible (n) {
      if (n) {
        // 查询当前支付订单状态
        let res = await this.checkOrderType()
        if (res) {
          this.$emit('success')
          this.handleWxPayClose()
        }
      } else {
        clearInterval(this.checkFunc)
      }
    }
  },
  methods: {
    handleWxPayClose () {
      this.$emit('update:visible', false)
    },
    checkOrderType () {
      return new Promise((resolve, reject) => {
        this.checkFunc = setInterval(() => {
          this.$http
            .get(
              `/front/consumer/shopping/order/orderInfo/${this.orderInfo.orderId}/false/0/0`,
              { params: { _noLoading: true } }
            )
            .then(({ data: { code, data } }) => {
              if (+code === 0 && data && +data.payStatus === 29) {
                resolve(true)
              }
            })
        }, 2000)
      })
    }
  }
}
</script>
<style lang="scss">
.pay-dialog {
  height: 634px;
}
</style>
<style lang="scss" scoped>
.p-main {
  height: 100%;
  padding-top: 45px;
}
.p-header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-bottom: 24px;
  img {
    margin-right: 14px;
  }
}
.p-price {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  margin-bottom: 17px;
}
.p-scan {
  margin-top: 48px;
  img {
    margin-right: 16px;
  }
  p {
    margin: 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
}
</style>
